import React, { useState } from "react"
import { Container, Row, Col, Card, CardBody, Button, Input, Form } from "reactstrap"
import SoldxHeader from "../../../components/SoldxHeader"
import SoldxBreadcrumb from "../../../components/SoldxBreadcrumb"
import SoldxLandingFooter from "../../../components/SoldxLandingFooter"

const BROKER_PRICE_MONTHLY = 7000
const BROKER_PRICE_YEARLY_PER_MONTH = 5000

const SubscriptionComingSoon = () => {
  const [email, setEmail] = useState("")
  const [submitted, setSubmitted] = useState(false)
  const [billingCycle, setBillingCycle] = useState<"monthly" | "yearly">("yearly")

  const handleNotifyMe = (e: React.FormEvent) => {
    e.preventDefault()
    if (email) {
      console.log("Notify email:", email)
      setSubmitted(true)
    }
  }


  return (
    <div className="soldx-landing">
      <SoldxHeader solid />

      <main className="subscription-page">
        {/* Hero Section */}
        <section className="subscription-hero">
          <div className="hero-shapes">
            <div className="shape shape-1"></div>
            <div className="shape shape-2"></div>
            <div className="shape shape-3"></div>
          </div>
          <SoldxBreadcrumb variant="hero" heroTone="light" className="mb-4" />
          <Container>
            <Row className="justify-content-center">
              <Col lg={8} className="text-center position-relative">
                <span className="hero-badge">
                  <i className="mdi mdi-star-four-points me-2" />
                  Coming Soon
                </span>
                <h1 className="hero-title">
                  SoldX <span>Premium</span> Plans
                </h1>
                <p className="hero-subtitle">
                  Unlock premium features and grow your real estate business
                </p>

              </Col>
            </Row>
          </Container>
        </section>

        {/* Buyer Banner */}


        {/* Broker Section */}
        <section className="py-5" style={{ background: "#f8fafc" }}>
          <Container>


            <Row className="justify-content-center">
              <Col lg={10}>
                <Card className="broker-card m-0">
                  <CardBody className="p-0">
                    <Row className="g-0">
                      <Col md={4} className="broker-card-left">
                        <div className="broker-icon">
                          <i className="mdi mdi-handshake" />
                        </div>
                        <h4>Broker Plan</h4>
                        <div className="broker-billing-toggle" role="group" aria-label="Billing period">
                          <button
                            type="button"
                            className={`broker-billing-option ${billingCycle === "yearly" ? "is-active" : ""}`}
                            onClick={() => setBillingCycle("yearly")}
                          >
                            Yearly
                          </button>
                          <button
                            type="button"
                            className={`broker-billing-option ${billingCycle === "monthly" ? "is-active" : ""}`}
                            onClick={() => setBillingCycle("monthly")}
                          >
                            Monthly
                          </button>
                        </div>
                        <div className="broker-price">
                          <span className="amount">
                            ₹
                            {(billingCycle === "yearly"
                              ? BROKER_PRICE_YEARLY_PER_MONTH
                              : BROKER_PRICE_MONTHLY
                            ).toLocaleString("en-IN")}
                          </span>
                          <span className="period">/month</span>
                        </div>
                        {billingCycle === "yearly" ? (
                          <p className="broker-price-note mb-0">
                            When billed yearly (₹{(BROKER_PRICE_YEARLY_PER_MONTH * 12).toLocaleString("en-IN")}/yr)
                          </p>
                        ) : (
                          <p className="broker-price-note mb-0">Billed every month</p>
                        )}
                      </Col>
                      <Col md={8} className="broker-card-right">
                        <div className="broker-features broker-features--blurred" aria-hidden="true">
                          <div className="feature-item">
                            <i className="mdi mdi-check-decagram text-success" />
                            <span>Refer unlimited buyers to properties</span>
                          </div>
                          <div className="feature-item">
                            <i className="mdi mdi-check-decagram text-success" />
                            <span>Earn commission on successful deals</span>
                          </div>
                          <div className="feature-item">
                            <i className="mdi mdi-check-decagram text-success" />
                            <span>Access dedicated broker dashboard</span>
                          </div>
                          <div className="feature-item">
                            <i className="mdi mdi-check-decagram text-success" />
                            <span>Track all your referrals & earnings</span>
                          </div>
                        </div>
                        <Button className="broker-btn" disabled>
                          <i className="mdi mdi-clock-outline me-2" />
                          Coming Soon
                        </Button>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </section>

        {/* Notify Section */}
        <section className="notify-section py-5">
          <Container>
            <Row className="justify-content-center">
              <Col lg={10} md={8}>
                <Card className="notify-card">
                  <CardBody className="p-4 p-md-5 text-center">
                    {!submitted ? (
                      <>
                        <div className="notify-icon">
                          <i className="mdi mdi-bell-ring-outline" />
                        </div>
                        <h4>Get Notified When We Launch</h4>
                        <p className="text-muted mb-4">
                          Be the first to know when our subscription plans go live!
                        </p>
                        <Form onSubmit={handleNotifyMe}>
                          <div className="notify-form">
                            <Input
                              type="email"
                              placeholder="Enter your email"
                              value={email}
                              onChange={(e) => setEmail(e.target.value)}
                              required
                            />
                            <Button color="primary" type="submit">
                              <i className="mdi mdi-send" />
                            </Button>
                          </div>
                        </Form>
                      </>
                    ) : (
                      <div className="notify-success">
                        <div className="success-icon">
                          <i className="mdi mdi-check-circle" />
                        </div>
                        <h4>You're on the list!</h4>
                        <p className="text-muted mb-0">
                          We'll notify you at <strong>{email}</strong> when we launch.
                        </p>
                      </div>
                    )}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </section>
      </main>

      <SoldxLandingFooter />
    </div>
  )
}

export default SubscriptionComingSoon
